
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 37 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.698 2.301c.039 4.483 1.485 8.096 4.419 11.039 1.595 1.598 1.68 3.814.228 5.927-2.353 3.418-4.328 6.577-4.57 10.28a8.256 8.256 0 017.369-4.47 8.261 8.261 0 017.373 4.471c-.242-3.701-2.216-6.861-4.569-10.281-1.454-2.112-1.369-4.328.228-5.929 2.933-2.942 4.379-6.554 4.417-11.037H8.698zm-2.351 0H4.892c-.606 0-1.099-.516-1.099-1.15S4.286 0 4.892 0h21.8c.605 0 1.098.516 1.098 1.151s-.493 1.15-1.098 1.15h-.748c-.038 5.13-1.706 9.282-5.099 12.685-.292.293-1.18 1.182.043 2.959 2.621 3.808 4.811 7.344 4.994 11.762h1.836V32H.008v-1.131-1.163h6.403c.183-4.42 2.373-7.954 4.994-11.762 1.222-1.777.335-2.667.044-2.958C8.056 11.583 6.387 7.431 6.348 2.3zm29.489 27.406c.602 0 1.094.516 1.094 1.149s-.492 1.145-1.094 1.145h-4.747c-.604 0-1.095-.512-1.095-1.145s.491-1.149 1.095-1.149h4.747zM21.131 7.345c0 .193-.055.367-.134.527-.952 2.922-2.797 4.734-4.851 4.734-2.059 0-3.908-1.818-4.858-4.748-.032-.067-.048-.139-.067-.213-.006-.028-.012-.054-.017-.087-.013-.071-.041-.138-.041-.213 0-.648.502-1.174 1.12-1.174h7.728c.618 0 1.12.526 1.12 1.174z"}})])
          )
        }
      }
    